import { useState, useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { uploadFile } from "../../../../apis/common-apis/fileApi";
import { AUDIT_PLAN_ALLOWED_TYPES } from "../utils/auditPlanFileUtils";

export const useAuditPlanAdd = (auditId, { onSuccess, onError } = {}) => {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const [adding, setAdding] = useState(false);

  const addFile = useCallback(
    async (file) => {
      if (!auditId || !file) return;

      const isAllowed = AUDIT_PLAN_ALLOWED_TYPES.some((ext) =>
        file.name?.toLowerCase().endsWith(ext)
      );
      if (!isAllowed) {
        onError?.(`Please select a valid file (${AUDIT_PLAN_ALLOWED_TYPES.join(", ")})`);
        return;
      }

      setAdding(true);
      try {
        const accessToken = await getAccessTokenSilently();
        const idToken = (await getIdTokenClaims()).__raw;
        const uploadResp = await uploadFile(
          file,
          "audit_document",
          auditId,
          undefined,
          accessToken,
          idToken,
          null,
          true
        );
        if (!uploadResp) {
          throw new Error("Upload returned no response");
        }
        onSuccess?.();
      } catch (err) {
        console.error("Audit plan add failed:", err);
        onError?.(err.message || "Failed to add audit plan");
      } finally {
        setAdding(false);
      }
    },
    [auditId, getAccessTokenSilently, getIdTokenClaims, onError, onSuccess]
  );

  return { adding, addFile };
};
